/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Changelog_Typedelete2Inputs */

const id_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus`)
};

const ms_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padam`)
};

const da_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet`)
};

const de_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen`)
};

const en_us2_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const es_es2_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const es_mx2_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const fil_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const fr_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression`)
};

const it_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina`)
};

const hu_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Törlés`)
};

const nl_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

const no_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slett`)
};

const pl_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usunięcie`)
};

const pt_br2_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir`)
};

const pt_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const ro_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ștergere`)
};

const fi_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poisto`)
};

const sv_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radering`)
};

const vi_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa`)
};

const tr_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sil`)
};

const cs_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazání`)
};

const bg_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтриване`)
};

const ru_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаление`)
};

const uk_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видалення`)
};

const ar_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف`)
};

const hi_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हटाएँ`)
};

const th_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบ`)
};

const ja_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

const zh_cn2_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除`)
};

const zh_hant1_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刪除`)
};

const ko_offerdetail_changelog_typedelete2 = /** @type {(inputs: Offerdetail_Changelog_Typedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`삭제`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Offerdetail_Changelog_Typedelete2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_typedelete2 = /** @type {((inputs?: Offerdetail_Changelog_Typedelete2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Typedelete2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_typedelete2(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_typedelete2(inputs)
	if (locale === "da") return da_offerdetail_changelog_typedelete2(inputs)
	if (locale === "de") return de_offerdetail_changelog_typedelete2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_typedelete2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_typedelete2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_typedelete2(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_typedelete2(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_typedelete2(inputs)
	if (locale === "it") return it_offerdetail_changelog_typedelete2(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_typedelete2(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_typedelete2(inputs)
	if (locale === "no") return no_offerdetail_changelog_typedelete2(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_typedelete2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_typedelete2(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_typedelete2(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_typedelete2(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_typedelete2(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_typedelete2(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_typedelete2(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_typedelete2(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_typedelete2(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_typedelete2(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_typedelete2(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_typedelete2(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_typedelete2(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_typedelete2(inputs)
	if (locale === "th") return th_offerdetail_changelog_typedelete2(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_typedelete2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_typedelete2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_typedelete2(inputs)
	return ko_offerdetail_changelog_typedelete2(inputs)
});
export { offerdetail_changelog_typedelete2 as "offerDetail.changelog.typeDelete" }